import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function ZenvaRedeem({ name, status, gameStatus, drmPlatform, zenvaId }) {
  if (status !== 'COMPLETE' || gameStatus === 'refunded' || drmPlatform !== 'zenva') return false;

  const openLink = (urlPassed) => {
    const win = window.open(urlPassed, '_blank');
    win.focus();
  };

  let url;

  if (zenvaId) {
    url = `https://academy.zenva.com/cart/?add-to-cart=${zenvaId}`;
  } else {
    switch (name) {
      case 'Bite-Sized HTML':
        url = 'https://academy.zenva.com/cart/?add-to-cart=999487';
        break;
      case 'Bite-Sized CSS':
        url = 'https://academy.zenva.com/cart/?add-to-cart=999509';
        break;
      case 'CSS Flexbox for Beginners':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1277641';
        break;
      case 'The Complete Beginner’s JavaScript Course':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1259575';
        break;
      case 'Discover Developer Tools for JavaScript Apps':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1283703';
        break;
      case 'Bite-Sized Python':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1214233';
        break;
      case 'C++ Programming for Beginners':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1747576';
        break;
      case 'Machine Learning for Beginners with TensorFlow':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1554252';
        break;
      case 'Web Scraping with Python and BeautifulSoup':
        url = 'https://academy.zenva.com/cart/?add-to-cart=698957';
        break;
      case 'Godot Game Development Mini-Degree [Early Access]':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1859561';
        break;
      case 'Beginning SQL – Store and Query Your Data':
        url = 'https://academy.zenva.com/cart/?add-to-cart=678844';
        break;
      case 'The Complete Python Data Visualization Course':
        url = 'https://academy.zenva.com/cart/?add-to-cart=662978';
        break;
      case 'Intro to Game Development with Unity':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1263755';
        break;
      case 'Learn C++ by Making a Text-Based RPG':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1747577';
        break;
      case 'Unity 2D Projects – Super Plumbers':
        url = 'https://academy.zenva.com/cart/?add-to-cart=999536';
        break;
      case 'Build a First-Person Shooter with Godot':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1873423';
        break;
      case 'Build a Micro-Strategy Game':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1631711';
        break;
      case 'Create a City Building Game with Unity':
        url = 'https://academy.zenva.com/cart/?add-to-cart=103864';
        break;
      case 'Create a Road Crossing Game with Phaser 3':
        url = 'https://academy.zenva.com/cart/?add-to-cart=107956';
        break;
      case 'Develop a Top-Down Action RPG with Phaser 3':
        url = 'https://academy.zenva.com/cart/?add-to-cart=119471';
        break;
      case 'Build a Tower Defense Game with Phaser 3':
        url = 'https://academy.zenva.com/cart/?add-to-cart=660625';
        break;
      case 'Intro to Augmented Reality':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1283708';
        break;
      case 'AR Game Development – Space Shooter':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1286063';
        break;
      case 'Build a Micro-VR Game':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1345128';
        break;
      case 'VR Projects – First-Person Shooter':
        url = 'https://academy.zenva.com/cart/?add-to-cart=70780';
        break;
      case 'Godot Game Development for Beginners':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1859561';
        break;
      case 'The Complete Beginners JavaScript Course':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1259575';
        break;
      case 'Beginning SQL - Store and Query Your Data':
        url = 'https://academy.zenva.com/cart/?add-to-cart=678844';
        break;
      case 'Unity 2D Projects - Super Plumbers':
        url = 'https://academy.zenva.com/cart/?add-to-cart=999536';
        break;
      case 'Build a Micro Strategy Game':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1631711';
        break;
      case 'Build a Micro-VR Game:':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1345128';
        break;
      case 'Craft Excel Pivot Tables for Data Reporting':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1290371';
        break;
      case 'Discover Excel Formulas':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1253531';
        break;
      case 'Excel Logic Functions for Beginners':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1253540';
        break;
      case 'Excel Tables for Beginners':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1290366';
        break;
      case 'Explore Conditional Excel Formatting':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1265478';
        break;
      case 'Intro to Excel':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1253513';
        break;
      case 'Intro to Excel Data Tools and Data Management':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1270703';
        break;
      case 'Lookup Functions for Excel':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1265483';
        break;
      case 'Manage Large Excel Spreadsheets':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1253522';
        break;
      case 'Statistical Formulas for Excel Data Analysis':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1270713';
        break;
      case 'Visualize Data with Excel Charts':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1284214';
        break;
      case 'Working with Excel Text Functions':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1281804';
        break;
      case 'Construct a Strategy Game with Godot':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2022613';
        break;
      case 'Game Development and Coding for Kids':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2238931';
        break;
      case 'Build a Micro-RPG':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1256271';
        break;
      case 'Game Character Customization with UMA':
        url = 'https://academy.zenva.com/cart/?add-to-cart=706831';
        break;
      case 'Create an RPG Town with NPCs and Dialogs':
        url = 'https://academy.zenva.com/cart/?add-to-cart=632166';
        break;
      case 'RPG Development – Turn-Based Battle System':
        url = 'https://academy.zenva.com/cart/?add-to-cart=626072';
        break;
      case 'Learn to Implement Game Saving':
        url = 'https://academy.zenva.com/cart/?add-to-cart=699279';
        break;
      case 'Create a 2D RPG with Godot':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1928616';
        break;
      case 'Develop a 3D Action RPG with Godot':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1954553';
        break;
      case 'Project-Based Oculus Avatars and Platform SDK':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1268926';
        break;
      case 'VR Pointers – Space Station App':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1009763';
        break;
      case 'Hand Grabbing Controllers in VR':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1296493';
        break;
      case 'Develop an AR App for the Retail Industry':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1286058';
        break;
      case 'Intro to ARKit':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1296445';
        break;
      case 'Intro to ARCore':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1290253';
        break;
      case 'VR Projects – Fitness Game':
        url = 'https://academy.zenva.com/cart/?add-to-cart=69445';
        break;
      case 'Intro to Unity Game Development':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2668809';
        break;
      case 'Shader Graph for Beginners':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1257217';
        break;
      case 'Develop a Technology Tree for Strategy Games':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1326360';
        break;
      case 'Create a Platformer Game in Unreal Engine':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2595715';
        break;
      case 'Angular for Beginners – Build a Language-Learning App':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2713377';
        break;
      case 'Discover AI and State Machines in Unity':
        url = 'https://academy.zenva.com/cart/?add-to-cart=117149';
        break;
      case 'Develop a Reusable Quiz System':
        url = 'https://academy.zenva.com/cart/?add-to-cart=945383';
        break;
      case 'Language Recognition AI with Unity and Azure':
        url = 'https://academy.zenva.com/cart/?add-to-cart=1007047';
        break;
      case 'Mobile Game Development for Beginners':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2701381';
        break;
      case 'Construct a Mobile Physics Game':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2688781';
        break;
      case 'Unreal Engine Game Development for Beginners':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2579434';
        break;
      case 'Build an Action RPG in Unreal Engine':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2621585';
        break;
      case 'Python Programming for Beginners':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2731403';
        break;
      case 'Learn Python and Pygame by Making a Game':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2731414';
        break;
      case 'The Complete Kivy App Development Course':
        url = 'https://academy.zenva.com/cart/?add-to-cart=2633319';
        break;
      case 'NumPy Matrices and Vectors':
        url = 'https://academy.zenva.com/cart/?add-to-cart=635107';
        break;
      case 'Python Image Processing-Make Instagram Style Filters':
        url = 'https://academy.zenva.com/cart/?add-to-cart=56827';
        break;
      case 'Video and Optical Flow-Create a Smart Speed Camera':
        url = 'https://academy.zenva.com/cart/?add-to-cart=58352';
        break;
      case 'Create a Raspberry Pi Smart Security Camera':
        url = 'https://academy.zenva.com/cart/?add-to-cart=57157';
        break;
      default:
        url = 'https://academy.zenva.com/';
    }
  }

  return (
    <button
      className="btn btn-zenva-message"
      onClick={() => openLink(url)}
    >
      <FormattedMessage id="zenva-redeem" defaultMessage="Click here to redeem your Zenva code" />
    </button>
  );
}

ZenvaRedeem.propTypes = {
  name: PropTypes.string,
  status: PropTypes.string,
  gameStatus: PropTypes.string,
  drmPlatform: PropTypes.string,
  zenvaId: PropTypes.string,
};

ZenvaRedeem.defaultProps = {
  name: '',
  status: '',
  gameStatus: '',
  drmPlatform: '',
  zenvaId: '',
};
